import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of, switchMap } from 'rxjs';
import { OttoOwnCrossReference } from '../../models/otto-olsen-cross-reference';
import { OttoOlsenCrossReferenceAdminService } from '../../services/otto-olsen-cross-reference-admin.service';

@Component({
  selector: 'otto-olsen-cross-reference-modal',
  templateUrl: './otto-olsen-cross-reference-modal.component.html',
  standalone: false
})
export class OttoOlsenCrossReferenceModalComponent implements OnInit {
  @Input() existing?: OttoOwnCrossReference;

  model: OttoOwnCrossReference = { crossReference: '', ottoProductId: '' };
  saving = false;
  error?: string;

  constructor(
    public activeModal: NgbActiveModal,
    protected adminService: OttoOlsenCrossReferenceAdminService
  ) {}

  ngOnInit(): void {
    if (this.existing) {
      this.model = { ...this.existing };
    }
  }

  save(): void {
    if (!this.model.crossReference?.trim() || !this.model.ottoProductId?.trim()) {
      this.error = 'CROSS_REFERENCE_REQUIRED_FIELDS';
      return;
    }
    this.saving = true;
    // Natural key = crossReference + ottoProductId. If either changed on an existing row,
    // the backend upsert would create a NEW row and leave the old one matching searches —
    // so delete the original first, then save.
    const keyChanged =
      !!this.existing?.id &&
      (this.existing.crossReference !== this.model.crossReference ||
        this.existing.ottoProductId !== this.model.ottoProductId);
    const deleteFirst$ = keyChanged ? this.adminService.delete(this.existing.id) : of(undefined);
    deleteFirst$
      .pipe(switchMap(() => this.adminService.save({ ...this.model, id: undefined })))
      .subscribe({
        next: () => this.activeModal.close(true),
        error: err => {
          this.saving = false;
          this.error = err?.error?.message || 'SAVE_FAILED';
        }
      });
  }
}
